module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0408-9eda32a76f00d31e4f77507ae25cfa6e.jpg";